import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ResourcesService } from '../../../services/resources.service';
import { DatePipe } from '@angular/common';
import { isEmpty } from 'rxjs';
import { ModalComponent } from '../../shared/modal/modal.component';
import * as BlobUtil from 'blob-util';
import { SowService } from '../../../services/sow.service';
import { ManualTSService } from '../../../services/manualts.service';
import { ReceiptsService } from '../../../services/receipts.service';

@Component({
  selector: 'app-receipts',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './receipts.component.html',
  styleUrls: ['./receipts.component.scss'],
    providers: [
      DatePipe
    ]
})
export class ReceiptsComponent implements OnInit {

  resource: any = {};
  listResourceSow: any = [];
  listPoNumber: any = [];
  listPoNumberField: any = [];
  listYear: any = [];
  listMonth: any = [];

  listVendor: any = [];
  listContract: any = [];
  upload: any = {};

  constructor(
    private __ref: DynamicDialogRef,
    private __sowService : SowService,
    private __datePipe: DatePipe,
    private __config: DynamicDialogConfig,
    private __dialogService : DialogService,
    private __manualTSService : ManualTSService,
    private __receiptsService : ReceiptsService
  ) {

  }

  ngOnInit(): void {
    this.getListYears();
    this.getListMonth();
    this.getListResourceSow();
    if (!this.isEmpty(this.__config.data.item)) {
      this.resource = this.__config.data.item;
      this.resource.ID = this.resource.ID;
      this.getListpoNumber();
      this.getListPoNumberField();
    } else {
      this.resource.ID = 0;
    }
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  getListYears() {
    //this.__spinner.show({ type: 'loader' });
    this.listYear = [];
    this.__receiptsService.getListYears().subscribe((resp: any) => {
      this.listYear = resp.listYear;
      //.__spinner.close();
    });
  }

  getListMonth() {
    //this.__spinner.show({ type: 'loader' });
    this.listMonth = [];
    this.__receiptsService.getListMonth().subscribe((resp: any) => {
      this.listMonth = resp.listMonth;
      //.__spinner.close();
    });
  }

  getListResourceSow() {
    //this.__spinner.show({ type: 'loader' });
    this.listResourceSow = [];
    this.__manualTSService.getListResourceSow().subscribe((resp: any) => {
      this.listResourceSow = resp.listResources;
      //.__spinner.close();
    });
  }

  selectItem(event: any) {
    let item = this.listResourceSow.find((e: any) => e.RESOURCE_ID == event);
    this.resource.RESOURCE_ID = item.RESOURCE_ID;
    this.resource.RESOURCE_NAME = item.USERNAME;
    this.resource.CONTRACTOR_ID = item.ADP_ID;
    this.resource.TYPE = item.TYPE;
    this.resource.VENDOR = item.CONTRACT;
    this.getListpoNumber();
  }

  selectItemPO(event: any) {
    let item = this.listPoNumberField.find((e: any) => e.PO_LINE_ID == event);
    this.resource.PO_LINE_ID = item.PO_LINE_ID;
    this.resource.PO_LINE_NO = item.PoNumber;
    this.resource.PO_LINE_DESK = item.DESCRIPTION;
    this.resource.RATE = item.UNIT_PRICE == null ? 0 : item.UNIT_PRICE;
  }

  getListpoNumber() {
    //this.__spinner.show({ type: 'loader' });
    this.listPoNumber = [];
    this.__receiptsService.getListPoNumber(this.resource.RESOURCE_ID).subscribe((resp: any) => {
      this.listPoNumber = resp.listData;
      //this.__spinner.close();
    });
  }

  getListPoNumberField() {
    //this.__spinner.show({ type: 'loader' });
    this.listPoNumberField = [];
    this.__sowService.getListpoNumber(this.resource.PONUMBER).subscribe((resp: any) => {
      this.listPoNumberField = resp.listPoNumber;
      //this.__spinner.close();
    });
  }

  saveReceipts() {
    //this.__spinner.show({ type: 'loader' });
    if (this.resource.RESOURCE_ID == undefined || this.resource.PONUMBER == undefined || this.resource.PO_LINE_ID == undefined ||
      this.resource.YEAR == undefined || this.resource.MONTH == undefined || this.resource.QUANTITY == undefined || this.resource.RECEIPT_NUMBER == undefined) {
        this.onShowMessage();
      return;
    }
    if (this.resource.RESOURCE_ID?.length == 0 || this.resource.PONUMBER?.length == 0 || this.resource.PO_LINE_ID?.length == 0 ||
      this.resource.YEAR?.length == 0 || this.resource.MONTH?.length == 0 || this.resource.QUANTITY?.length == 0 || this.resource.RECEIPT_NUMBER?.length == 0) {
        this.onShowMessage();
      return;
    }
    this.__receiptsService.saveReceipts(this.resource).subscribe((resp: any) => {
      if(+resp?.an_resultado==0) {
        //this.__spinner.close();
        this.accept();
      }
    });
  }

  /**
   *
   * @param event
   * @returns
   */
  handleFileInput(event : any) {
    this.upload.fileName = event.target.files[0].name;
    this.upload.fileType = event.target.files[0].type;
    BlobUtil.blobToBase64String(event.target.files[0]).then((res) => {
      this.upload.fileUpload = res;
      this.resource.SOWDOC = this.upload.fileUpload;
    });
  }

  onShowMessage() {
    let confirm = this.__dialogService.open(ModalComponent, {
      width: '30%',
      header: 'Complete fields required',
      dismissableMask: false,
      closable: false,
    });

    confirm?.onClose.subscribe((resp: any) => {
    });
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'success'
    }
    this.__ref.close(data);
  }

  onQuantityInput(event: any): void {
    const input = event.target.value;
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(input)) {
      event.target.value = input
        .replace(/[^0-9.]/g, '')
        .replace(/(\..*?)\..*/g, '$1')
        .replace(/^(\d*\.\d{0,2}).*$/, '$1');
      this.resource.QUANTITY = event.target.value;
    } else {
      this.resource.QUANTITY = input;
    }
    if (this.resource.RATE !== null || this.resource.RATE !== undefined) {
      this.resource.AMOUNT_RECEIVED = this.resource.RATE * this.resource.QUANTITY;
    }
  }

}
